import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { PCTableActionInputModel } from '../../models/pc-table-action-input-model';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { TabelPaging } from '../../interfaces/table';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { LoggerService } from 'src/app/services/logger.service';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { EnumUtilityService } from 'src/app/services/enum-utility.service';
import { SaleFactorType } from 'src/app/enum/sale-factor-type';
import { DocumentType } from 'src/app/enum/document-type';
import { Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PCTableComponent } from '../../components/pctable/pctable.component';
import { PcsettingModalComponent } from '../../components/pcsetting-modal/pcsetting-modal.component';
import { FactorReportFilter } from '../../models/factor-report-filter';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { SaleReportFilter } from '../../models/sale-report-filter';
import { NewCalendarService } from 'src/app/services/new-calender-service';

@Component({
  selector: 'app-sale-table',
 templateUrl: './sale-table.component.html',
  styleUrl: './sale-table.component.css'
})
export class SaleTableComponent implements OnInit{
  constructor(
    private logger: LoggerService,
    private router: Router,
    private enumService: EnumUtilityService,
    private apiService: UserApiService,
    private modalService: NgbModal,
    public calendarService: NewCalendarService,
    private responseService: CustomizeResponseService
  ) {
    this.requestModel = new PCSearchRequestModel();
    this.endPoint='';
    this.title='';
    this.filterData = new SaleReportFilter();
    this.action = new PCTableActionInputModel(
      [
        {
          name: 'Reload',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
        {
          name: 'Settings',
          className: 'btn-outline-primary',
          icon: 'bx bx-cog',
        },
        {
          name: 'Filter',
          className: 'btn-outline-primary',
          icon: 'fas fa-filter',
        },
        {
          name: 'Prescription-OTC',
          className: 'btn-outline-primary',
          icon: 'fas fa-prescription-bottle-alt',
        },
        {
          name: 'ElectronicPrescription',
          className: 'btn-outline-primary',
          icon: 'fas fa-prescription',
        },
        {
          name: 'Explanation',
          className: 'btn-outline-primary',
          icon: 'bx bx-question-mark',
        },
      ],
      '',
      []
    );

    this.generateUrl();
   
  }

  public ngOnInit(): void {
    this.action.title=this.title;
    forkJoin([this.getData(), this.getEntity()]).subscribe(
      ([dataResult, entityResult]) => {
        if (dataResult) {
          this.logger.addResponseLog(this.endPointUrl, dataResult, `Get All`);
          if (dataResult.succeeded) {
            let firstItemOnPage = dataResult.data?.firstItemOnPage || 1;

            if (dataResult.data?.pageCount! < dataResult.data?.pageNumber! && dataResult.data?.pageCount!=0) {
              this.requestModel.pageNumber = 1;
              this.getSingleData();
            }
            this.data = new PCTableInputModel(
              dataResult.data?.items,
              [
                {
                  name: 'PrintItem',
                  className: 'btn-outline-primary',
                  icon: 'bx bx-printer',
                },
                {
                  name: 'Return',
                  className: 'btn-outline-danger',
                  icon: 'fa fa-undo',
                },
              ],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.paging = this.responseService.customizePaging(dataResult);
          }
        }

        if (entityResult) {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            entityResult,
            `Get Entity`
          );
          if (entityResult.succeeded) {
            let fields = this.apiService.convertStringToBoolean(
              entityResult.data.fields
            );

            fields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            this.fields = fields;
          }
        }

        setTimeout(() => {
          if (this.pcTableComponent) {
            this.pcTableComponent.InitPage();
          } else {
            console.error('PCTableComponent not found');
          }
        }, 2);

        setTimeout(() => {
          let selectStockPage = document.getElementById('selectStockPage');
          if (selectStockPage) {
            selectStockPage.classList.remove('animate__backInDown');
          }
        }, 2000);

        this.listLoading = false;
      },
      (error) => {
        this.apiService.AddErrorLog(error);
        this.listLoading = false;
      }
    );
    if(this.endPoint=='SaleFactor'){
      this.action.buttons.splice(2,1);
    }
  }
  
  @Input() endPoint: string ;
  @Input() title: string ;
  public listLoading: boolean = true;
  public action: PCTableActionInputModel;
  public data?: PCTableInputModel;
  public fields: any[] = [];
  public paging?: TabelPaging;
  public requestModel: PCSearchRequestModel;
  public endPointUrl!: string;
  public recept: any;
  public monthName: string = '';
  public returnModalOpen: boolean = false;
  public receptModalIsOpen: boolean = false;
  public modalSuccessOpen: boolean = false;

  @ViewChild(PCTableComponent) pcTableComponent!: PCTableComponent;
  @ViewChild(PcsettingModalComponent)
  pcsettingModalComponent!: PcsettingModalComponent;
  @ViewChild('datePicker') public popoverDataPicker!: NgbPopover;
  @ViewChild('searchFilter') searchFilterModal!: ElementRef;


  public searchField: any[] = [];
  public filterData: SaleReportFilter;

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.listLoading = true;
        if (this.requestModel.orderBy == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.orderBy != event.data) {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == 'asd') {
          this.requestModel.direction = 'desc';
        }

        this.requestModel.orderBy = event.data;

        this.generateUrl();
        this.getSingleData();
        break;
      case 'Search':
        this.listLoading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.search = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Paging':
        this.listLoading = true;

        this.requestModel.pageNumber = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'PageSize':
        this.listLoading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.pageSize = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Filter':
        this.openModal(this.searchFilterModal);
        break;
      case 'Reload':
        this.listLoading = true;
        this.requestModel.pageNumber = 1;
        this.filterData = new SaleReportFilter();
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Return':
        this.return(event.data);
        break;
      case 'PrintItem':
        //TODO
        this.getDetailPrint(event.data.id);
        // this.callParent('PrintItem', event.data);
        break;
      case 'ClosePrintModal':
        //this.clear();
        this.receptModalIsOpen = false;
        break;
      case 'ElectronicPrescription':
        this.router.navigate(['ElectronicPrescription']);
        break;
      case 'Prescription-OTC':
        this.router.navigate(['Sale']);
        break;
      case 'Successed':
        this.modalSuccessOpen = false;
        break;

      case 'Settings':
        this.pcsettingModalComponent.openSettingModal();
        break;
      case 'SubmitSetting':
        this.fields = event.data;
        if (this.pcTableComponent) {
          this.pcTableComponent.RebuildColumn();
        } else {
          console.error('PCTableComponent not found');
        }
        break;
      default:
        break;
    }
  }

  public openModal(content: any) {
    try {
      this.modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
          },
          (reason) => {}
        );
    } catch (error) {}
  }

  public generateUrl() {
    if (!this.requestModel.orderBy || this.requestModel.orderBy == '') {
      this.requestModel.orderBy = 'DateAdded';
      this.requestModel.direction = 'desc';
    }
    this.endPointUrl = `${this.endPoint}?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;
  }

  public clearEditItem() {
    this.filterData = new SaleReportFilter();
  }

  public getSingleData() {
    try {
      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.endPointUrl))
      ) {
        return;
      }
      this.modalService.dismissAll();
      this.listLoading = true;
      this.apiService
        .getAllWithFilter(
          new ApiRequestModel(this.endPointUrl),
          this.filterData
        )
        .subscribe(
          (result) => {
            this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
            if (result.succeeded) {
              let firstItemOnPage = 1;
              if (result.data?.firstItemOnPage) {
                firstItemOnPage = result.data?.firstItemOnPage;
              }

              if (result.data?.pageCount! < result.data?.pageNumber!) {
                this.requestModel.pageNumber = 1;
              }

              this.data = new PCTableInputModel(
                result.data?.items,
                [
                  {
                    name: 'PrintItem',
                    className: 'btn-outline-primary',
                    icon: 'bx bx-printer',
                  },
                  {
                    name: 'Return',
                    className: 'btn-outline-danger',
                    icon: 'fa fa-undo',
                    condition: 'returnId',
                  },
                ],
                true,
                firstItemOnPage,
                this.requestModel.orderBy,
                this.requestModel.direction
              );

              this.paging = this.responseService.customizePaging(result);

              setTimeout(() => {
                let selectStockPage =
                  document.getElementById('selectStockPage');
                if (selectStockPage) {
                  selectStockPage.classList.remove('animate__backInDown');
                }
              }, 2 * 1000);
            } else {
              this.logger.addBackEndMessage(result);
            }
            this.listLoading = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.listLoading = false;
          },
          () => {
            this.listLoading = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.listLoading = false;
    }

    setTimeout(() => {}, 700);

    setTimeout(() => {
      let selectStockPage = document.getElementById('StockDetail');
      if (selectStockPage) {
        selectStockPage.classList.remove('animate__backInDown');
      }
    }, 2 * 1000);
  }

  public getData() {
    this.generateUrl();
    return this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).pipe(
      catchError((error) => {
        this.apiService.AddErrorLog(error);
        this.listLoading = false;
        return of(null);
      })
    );
  }

  public getEntity() {
    return this.apiService
      .getEntity(
        new ApiRequestModel(
          this.endPoint,
          null,
          undefined,
          this.endPoint,
          'SaleFactor'
        )
      )
      .pipe(
        catchError((error) => {
          this.apiService.AddErrorLog(error);
          return of(null);
        })
      );
  }

  public clear() {
    this.recept = undefined;
  }

  public getDetailPrint(itemID: string) {
    try {
      if (this.recept != null && this.recept.id == itemID) {
        this.receptModalIsOpen = true;
        return;
      }
      this.listLoading = true;
      let url = `${this.endPoint}/Print/${itemID}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            this.recept = result.data;
            this.receptModalIsOpen = true;
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.listLoading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.listLoading = false;
        },
        () => {
          this.listLoading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.listLoading = false;
    }
  }

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  private return(viewModel: any) {
    try {
      if (viewModel == null) {
        return;
      }

      if (viewModel.id == null || viewModel.id == '') {
        return;
      }

      if (viewModel.saleState == '50' || viewModel.saleState == '10') {
        this.logger.addError('SaleFactoryReturnedError', false);
        return;
      }

      let endPointUrl = `SaleFactorReport/ReturnFactor`;

      let backEndJson = {
        taminToken: '',
        slamatToken: '',
        saleFactorId: viewModel.id,
        nationalNumber:viewModel.patientNationalCode,
        detailIds: [],
      };

      if (viewModel.saleFactorType == '0') {
        endPointUrl = `SaleElectronicPrescription/Tamin/RemovePresc?id=${viewModel.id}`;
        this.listLoading = true;
        this.apiService
          .getSingleItem(new ApiRequestModel(endPointUrl))
          .subscribe(
            (result) => {
              this.logger.addResponseLog(
                endPointUrl,
                result,
                `Get Single Item`
              );
              if (result.succeeded) {
                this.generateUrl();
                this.getSingleData();
                this.modalSuccessOpen = true;
              } else {
                this.logger.addBackEndMessage(result);
              }

              this.listLoading = false;
            },
            (error) => {
              this.apiService.AddErrorLog(error);
              this.listLoading = false;
            },
            () => {}
          );
        return;
      }

      this.listLoading = true;

      if (!this.apiService.tokenValidation(new ApiRequestModel(endPointUrl))) {
        return;
      }


      this.apiService
        .postItem(new ApiRequestModel(endPointUrl, backEndJson))
        .subscribe(
          (result) => {
            this.logger.addResponseLog(endPointUrl, result, `Get Single Item`);
            if (result.succeeded) {
              this.generateUrl();
              this.getSingleData();
              this.modalSuccessOpen = true;
            } else {
              this.logger.addBackEndMessage(result);
            }
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.listLoading = false;
          },
          () => {}
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.listLoading = false;
    }
  }
}
